export default class rmLangblocks {
    constructor() {
        return {
            scope: false,
            restrict: 'A',
            controller: LanguageBlockCtrl,
            controllerAs: 'rmLang'
        };
    }
};

class LanguageBlockCtrl {
    constructor($scope, $attrs, $element) {
        this._scope = $scope;
        this._element = $element;
        this._attrs = $attrs;

        this.currentLang = "";

        this._scope.$on('mailEditor:language:toggle', (event, toLanguage) => {
            this.toggleLanguageBlocks(toLanguage);
        });

        if (this._attrs.getLanguagesFromChildren) {
            this._scope.$on('smsEditor:language:toggle', (event, toLanguage) => {
                this.currentLang = toLanguage;
                this.parseChildrenAndSetCurrent();
            });
            this._scope.$watch(angular.bind(this, this.getLocaleElsCount), () => {
                this.parseChildrenAndSetCurrent();
            });
        }
    }
    
    toggleLanguageBlocks(language) {
        if (angular.isObject(language)) {
            return;
        }

        this.currentLang = language;

        angular.forEach($('[data-language]'), (block) => {
            (block.getAttribute('data-language') == language) ? block.classList.remove('hidden') : block.classList.add('hidden');
        });
    };

    parseAvailableLanguagesFromChildren() {
        let localeEls = this._element.find('[data-language]');
        return localeEls.map(function(el) {
            return $(this).attr("data-language");
        }).get();
    };

    getLocaleElsCount() {
        return $(this._element[0]).find('[data-language]').length;
    };

    parseChildrenAndSetCurrent() {
        this.availableLanguages = this.parseAvailableLanguagesFromChildren();

        if (this.currentLang) {
            this.toggleLanguageBlocks(this.currentLang);
        }
        if (this.availableLanguages.length) {
            this._scope.$broadcast('rmLanguages:availableLanguages', {languages: this.availableLanguages, currentLang: this.currentLang});
        }
    };
}
